/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTopicRequest } from '../../models/create-topic-request';
import { Topic } from '../../models/topic';

export interface BulkCreateTopic$Params {
      body: Array<CreateTopicRequest>
}

export function bulkCreateTopic(http: HttpClient, rootUrl: string, params: BulkCreateTopic$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Topic>>> {
  const rb = new RequestBuilder(rootUrl, bulkCreateTopic.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Topic>>;
    })
  );
}

bulkCreateTopic.PATH = '/v0/topics/bulk-create';
